import { addEmployeeType } from "../../../../../actions/Utilities/EmployeeType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useAddEmployeeType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (employeeTypeNewData) => addEmployeeType(employeeTypeNewData),
    {
      onSuccess: (res) => {
        if (res == "Duplicate") {
          toast.fire("Saving Failed", "Employee Type already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetEmployeeType"]);
          toast.fire("Success", "Added Employee Type Successfully", "success");
        }
      },
      onError: (error) => {
        toast.fire("Failed", "Failed to Add Employee Type", "error");
      },
    }
  );

  return mutate;
};
export default useAddEmployeeType;
